import "../styles/app.scss";
import "./_images";
import { CreateCampaign } from "./Components/CreateCampaign";
import { EditCampaign } from "./Components/EditCampaign";
import { MobileNavigation } from "./Components/MobileNavigation";
import { LoginComponent } from "./Components/LoginComponent";
import { CSSVariables } from "./Components/CSSVariables";
import { MyAccountStats } from "./Components/MyAccountStats";
import { FAQ } from "./MyAccount/FAQ";
import { MyAccountParticipantDashboard } from "./Components/MyAccountParticipantDashboard";
import { Plyr } from "./Components/Plyr";
import { MyAccountTutorials } from "./Components/MyAccountTutorials";
import { MyAccountSettings } from "./Components/MyAccountSettings";
import { TopTeamsParticipants } from "./Components/TopTeamsParticipants";
import {ScrollTo} from './Components/ScrollTo.js'
import { MyAccountCampaignEdit } from "./MyAccount/MyAccountCampaignEdit";
import {Additional} from "./Components/Additional";

import "plyr/dist/plyr.css";
import { SocialShareQR } from "./Components/SocialShareQR";

/* LAX animations */
import { LaxAnimations } from "./Components/LaxAnimations";

__webpack_public_path__ = document.currentScript.src.replace(
  /\/scripts\/[^\/]+$/,
  "/"
);

document.addEventListener(
  "DOMContentLoaded",
  () => {
    new LaxAnimations();



    new CSSVariables();
    new CreateCampaign();
    new EditCampaign();
    new MobileNavigation();
    new LoginComponent();
    new ScrollTo();
    console.log("App ready");


    const pathname = window.location.pathname.replace(/^\/+|\/+$/g, "");
    if (["my-account/my-campaign", "my-account/my-team"].includes(pathname)) {
      new MyAccountStats();
    }
    new FAQ();
    new MyAccountParticipantDashboard();
    new Plyr();
    new MyAccountTutorials();
    new MyAccountSettings();
    new TopTeamsParticipants();
    new MyAccountCampaignEdit();
    new SocialShareQR();
    new Additional();
    setTimeout(function (){
       if ( document.querySelector('.woocommerce-form-login input#username')){
           document.querySelector('.woocommerce-form-login input#username').placeholder = 'Username';
       }
    })


  },
  false
);
